import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// No booking calendar exists for this clinic on the new site. Old links (Google
// Business Profile, emails) land on the full scheduler, where the visitor
// picks the clinic.
export const Route = createFileRoute("/schedule-a-consult/south-lake")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/schedule-a-consult/", location.searchStr), statusCode: 301 });
  },
});
